import { Component, ElementRef, Input, OnInit, OnDestroy, TemplateRef, Inject } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { TargetingSearchService } from '../../../../Discover/Targeting/services/targeting-search.service';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { TargetingListService } from '../../../../Discover/Targeting/services/targeting-list.service';
import { ListPickerService } from '../../services/list-picker.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { ResultCardDirective } from '../../../TargetingShared/components/ResultCard/result-card.directive';
import { OutletContactTabType, TargetingRhpContextsService } from '../../../TargetingShared/services/targeting-rhp-contexts.service';
import { EntityTypeDefaultImageEnum } from '../../../Misc/enums/entity-type-default-image.enum';
import { ManageListDialogComponent } from '../../../../Discover/Targeting/components/TargetingResults/ManageListDialog/manage-list-dialog.component';
import { TargetingResultModel } from '../../../../Discover/Targeting/models/targeting-result.model';
import { DistributionPickerService } from '../../services/distribution-picker.service';
import { ManageDistDialogComponent } from '../../../../Discover/Targeting/components/TargetingResults/ManageDistDialog/manage-dist-dialog.component';


@Component({
    selector: 'agpr-outlet-card',
    templateUrl: './outlet-card.component.html',
    styleUrls: ['../../../TargetingShared/components/ResultCard/result-card.scss'],
    standalone: false
})
export class OutletCardComponent extends ResultCardDirective implements OnInit, OnDestroy {

    @Input() contextMenuTemplate: TemplateRef<any> = null;
    @Input() initiallyFocusable: boolean = true;

    selectedOutletId: string;
    imageDefault = EntityTypeDefaultImageEnum;
    reachTooltip: string;

    constructor(
        public targetingSearchService: TargetingSearchService,
        public targetingListService: TargetingListService,
        public listPickerService: ListPickerService,
        public localizationService: LocalizationService,
        public coreDialogService: CoreDialogService,
        public targetingRhpContextsService: TargetingRhpContextsService,
        public distributionPickerService: DistributionPickerService,
        private el: ElementRef,
        @Inject (APP_BASE_HREF) public appBaseHref: string
    ) {
        super(targetingSearchService,
            targetingListService,
            listPickerService,
            localizationService,
            coreDialogService,
            targetingRhpContextsService,
            distributionPickerService);
        this.targetingRhpContextsService.getOutletId().subscribe(outletId => {
            this.selectedOutletId = outletId;
        });
    }
    ngOnInit(): void {
        this.reachTooltip = this.isReachValueFromSimilarWeb ? this.localizationService.transform(
            'Common.audienceReach.similarweb.tooltip.insightsBy',
            {src: this.appBaseHref + 'assets/images/SimilarWeb-logo-with-text.svg'}
        ) : null;
    }
    openManageListDialog(entity: TargetingResultModel) {
        this.coreDialogService.open(ManageListDialogComponent, {
            inputs: {
                setEntity: entity
            },
            outputs: {}
        });
    }

    openManageDistDialog(entity: TargetingResultModel) {
        this.coreDialogService.open(ManageDistDialogComponent, {
            inputs: {
                setEntity: entity
            },
            outputs: {}
        });
    }
    focusOutlet(event: any) {
        event.preventDefault(event);
        // TODO : Maybe this should pop a takeover instead of selecting
        this.targetingRhpContextsService.setEntityByResult(this.entityInternal);
        this.targetingRhpContextsService.selectOutletContactTab(OutletContactTabType.outletProfile);
    }
}
